import { Component, inject, OnInit } from '@angular/core';
import { first } from 'rxjs';
import { Offer } from '../../../../../models/offer';
import { OfferService } from '../../../../../services/offers/offer.service';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';

/**
 * The logged-in customer's own open offers (ERP-synced, OfferService.getOpenOffers()) - not the
 * admin-curated 'cart-list'/'quote-list' block above, which reads saved carts tagged QUOTE
 * (CartsService.getQuotes()), a different, unrelated feature. There is no admin selection here:
 * every field just shapes how the viewer's own live data is shown.
 */
@Component({
  selector: 'lib-dynamic-page-dc-offer-list',
  standalone: false,
  templateUrl: './dynamic-page-dc-offer-list.component.html',
  styleUrl: './dynamic-page-dc-offer-list.component.scss'
})
export class DynamicPageDcOfferListComponent extends DynamicPageDcBaseComponent implements OnInit {
  private offerService = inject(OfferService);

  elementId = 'offer-list';
  fields = {
    title: 'Continue where you left off',
    limit: 3,
    emptyText: 'You have no saved offers right now.',
    buttonText: 'Open offer',
    buttonBackground: '#000000',
    buttonColor: '#ffffff',
    buttonHoverBackground: null as string | null,
    buttonHoverColor: null as string | null,
    buttonBorderRadius: 6,
    buttonFontSize: 13,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0
  };

  offers: Offer[] = [];
  loading = true;

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.mode === 'renderer') {
      this.offerService
        .getOpenOffers()
        .pipe(first())
        .subscribe({
          next: offers => {
            this.offers = (offers || [])
              .slice()
              .sort((a, b) => this.offerDate(b) - this.offerDate(a))
              .slice(0, Number(this.element.fields.limit) || this.fields.limit);
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          }
        });
    }
  }

  openOffer(offer: Offer): void {
    this.btnClick(null, `/offers/${offer.id}`);
  }

  offerDate(offer: Offer): number {
    const date = offer?.extra?.gungSalesOrder?.orderDate;
    return date ? new Date(date).getTime() : 0;
  }
}
